module.exports = __webpack_public_path__ + "static/media/CP_2022_chTradi_membraneRTMAX_anciennes_suspensions.a24900c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CP_2022_chTradi_membraneRTMAX_anciennes_suspensions.jpg
// module id = 1155
// module chunks = 0